export enum InputVariantsEnum {
  Primary = 'Primary',
  Secondary = 'Secondary',
}

export type InputVariantsType = keyof typeof InputVariantsEnum;
